module.exports = __webpack_public_path__ + "img/m.bacf608b.png";